<template>
    <section class="container mt-3 py-3">
        <h4>Selects</h4>
        <!-- Default -->
        <div class="my-2 ms-3 my-4">
            <h5>Default</h5>
            <!-- implementación -->
            <px-select idSelect="Example" placeholder="Opciones" :options="listado" @KuramaSelect="itemSeleccionado = $event" class="mb-2"></px-select>
            <!-- <code>{{itemSeleccionado}}</code> -->
            <!--  -->
            <!-- CODIGO HTML -->
            <p class="text-dark my-0">Código de ejemplo para la implementación de select.</p> 
            <div v-highlight>
<pre class="language-html"><code><script type="text/plain" class="language-markup"><px-select idSelect="Example" placeholder="Opciones" :options="listado" @KuramaSelect="itemSeleccionado = $event"></px-select>
</script></code></pre>
            </div>
            <p class="text-dark my-0 mt-4">Código de ejemplo para la implementación de select.</p>
            <!-- CODIGO QUE SE MUESTRA --> 
            <div v-highlight>
<pre class="language-javascript"><code>
export default {
    data: function(){
        return{
            itemSeleccionado: [],
            listado:[
                {id:0,text:'go'},
                {id:1,text:'java'},
                {id:2,text:'javascript'},
                {id:3,text:'php'},
                {id:4,text:'html'},
            ],
        }
    }
}</code></pre>
            </div>
        </div>
        <!-- Selección múltiple -->
        <div class="my-2 ms-3 mt-5 mb-4">
            <div class="d-none">
                <h5>Selección Múltiple</h5>
                <!-- implementación -->
                <px-select-multiple idSelect="SelectMultipleExample" :options="listado2" @KuramaSelectMultiple="itemSeleccionadoMultiple = $event"></px-select-multiple>
                <p class="text-dark my-0">Código de ejemplo para la implementación de select múltiple.</p>
                <!-- CODIGO HTML -->
                <div v-highlight>
    <pre class="language-html"><code><script type="text/plain" class="language-markup"><px-select-multiple idSelect="Sel" :options="listado" @KuramaSelectMultiple="itemSelecMultiple = $event"></px-select-multiple>
    </script></code></pre>
                </div>

                <p class="text-dark my-0 mt-2">Código de ejemplo para la implementación de select.</p>
                <!-- CODIGO QUE SE MUESTRA --> 
                <div v-highlight>
    <pre class="language-javascript"><code>
    export default {
        data: function(){
            return{
                itemSelecMultiple: [],
                listado:[
                    {id:0,text:'go',check:false},
                    {id:1,text:'java',check:false},
                    {id:2,text:'javascript',check:false},
                    {id:3,text:'php',check:false},
                    {id:4,text:'html',check:false},
                    {id:5,text:'css',check:false},
                ],
            }
        }
    }</code></pre>
                </div>

            </div>
            <div class="mb-3">
                <p class="mb-2 mt-3">Propiedades que debe tener el componente select (px-select) para su funcionamiento</p> <!---------- y select múltiple (px-select-multiple) ------------->
                <table class="table" style="font-size:.8rem;">
                    <thead>
                        <tr>
                        <th width="35%" scope="col">Propiedad</th>
                        <th scope="col">Atributo</th>
                        <th scope="col">Descripción</th>
                        </tr>
                    </thead>
                    <tbody class="table-group-divider">
                        <tr v-for="(desc, index) in descripcionAtributos" :key="index">
                        <th width="35%" scope="row"> <code>{{desc.propiedad}}</code> </th>
                        <td style="font-size:.7rem;">{{desc.atributo}}</td>
                        <td>{{desc.descripcion}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="mt-5 mb-3">
                <h5>Tratado de la lista de objetos</h5>
                <p class="text-dark mt-2 mb-1">El objeto que representa cada una de las opciones del select debe de tener ciertas propiedades para su correcta función.</p>
                 <code>
                    <span class="text-dark ms-2">Objeto select default:</span> {id:0, text:'go'} <br>
                    <span class="text-dark ms-2">Objeto select múltiple:</span> {id:0, text:'go', check:false}<br>
                </code>

                <p class="text-dark mt-5 mb-3">Para adaptar el objeto con estas propiedades hay que tratar el listado con el método <span  class="fst-italic">map()</span> y guardar la lista resultante en una variable (En este caso <code>listaNuevo</code>
               . Esta variable se utilizara en el atributo <code>:options</code> del select.</p>
                <!-- CODIGO QUE SE MUESTRA --> 
                <div v-highlight>
<pre class="language-javascript"><code>//Opciones para el select default
this.listaNuevo = this.listado.map(function(Obj){
    let myObj = {};
    myObj.id = Obj.id;
    myObj.text = Obj.descripcion;
    return myObj;
});

<!-- //Opciones para el select múltiple
this.listaNuevoMultiple = this.listado.map(function(Obj){
    let myObj = {};
    myObj.id = Obj.id;
    myObj.text = Obj.descripcion;
    myObj.check = false;
    return myObj;
}); -->
</code></pre>
                </div>


            </div>
            <div class="mt-5 mb-3">
                <h5>Seteo de valores del select</h5>
                <p class="text-dark mt-2 mb-1">Para agregar un valor por default al select básico hay que indicar en la propiedad <code>:values</code> la id con el valor a setear</p>
                <!-- implementación -->
                <px-select idSelect="selectExampleValorDefault" :options="listado" :values="0" @KuramaSelect="itemSeleccionado = $event" class="mb-2"></px-select>
                <!-- <code>{{itemSeleccionado}}</code> -->
                <!--  -->
                <!-- CODIGO HTML -->
                <p class="text-dark my-0">Código de ejemplo para la implementación de select.</p> 
                <div v-highlight>
<pre class="language-html"><code><script type="text/plain" class="language-markup"><px-select idSelect="ExampleValorDefault" :options="listado" :values="0" @KuramaSelect="itemSeleccionado = $event"></px-select>
</script></code></pre>
            </div>



            </div>
        </div>

        <!-- ===================================================================================== -->
    </section>
</template>
<script>
// import PxSelect from '@/components/PxSelect.vue';
// import PxSelectMultiple from '@/components/PxSelectMultiple.vue'
export default {
    created(){
        window.scrollTo(0, 0);
    },
    // components:{PxSelect, PxSelectMultiple},
    data: function(){
        return{
            listado:[
                {id:0,text:'go'},
                {id:1,text:'java'},
                {id:2,text:'javascript'},
                {id:3,text:'php'},
                {id:4,text:'html'},
            ],
            listado2:[
                {id:0,text:'go',check:false},
                {id:1,text:'java',check:false},
                {id:2,text:'javascript',check:false},
                {id:3,text:'php',check:false},
                {id:4,text:'html',check:false},
                {id:5,text:'css',check:false},
                {id:6,text:'rubik',check:false},
                {id:7,text:'pearl',check:false},
                {id:8,text:'arduino',check:false},
                {id:9,text:'pascal',check:false},
                {id:10,text:'c++',check:false},
                {id:11,text:'c',check:false},
                {id:12,text:'python',check:false},
            ],
            itemSeleccionado: [],
            itemSeleccionadoMultiple: [],
            descripcionAtributos: [
                { 'propiedad': 'idSelect', 'atributo': 'String', 'descripcion': 'Id del select, necesario cuando en la vista habra más de un select' },
                { 'propiedad': ':disable', 'atributo': 'Boolean', 'descripcion': 'Deshabilita el select al agregar el valor de true (valor por default: false).' },
                { 'propiedad': 'placeholder', 'atributo': 'String', 'descripcion': 'Propiedad para personalizar el placeholder del select'},
                { 'propiedad': ':options', 'atributo': 'Array de objetos', 'descripcion': 'Array mapeado con las opciones del select.' },
                { 'propiedad': '@KuramaSelect="itemSeleccionado = $event"', 'atributo': 'evento', 'descripcion': 'Evento exclusivo para el componente px-select que captura en una variable (en este caso itemSeleccionado) el valor de la opción seleccionada.'},
                // { 'propiedad': '@KuramaSelectMultiple="itemSeleccionado = $event', 'atributo': 'evento', 'descripcion': 'Evento exclusivo para el componente px-select-multiple que captura en una variable (en este caso itemSeleccionado) el valor de las opciones seleccionadas.'},
            ],
            // =======================================================
    }
    },
    
}
</script>